<template>
  <el-dialog
    title="更新充值状态"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="rechargeForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="订单号">
        <el-input v-model="formData.order_no" disabled />
      </el-form-item>

      <el-form-item label="套餐名称">
        <el-input v-model="formData.package_name" disabled />
      </el-form-item>

      <el-form-item label="订单金额">
        <el-input v-model="formData.price" disabled>
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>

      <el-form-item label="充值状态" prop="recharge_status">
        <el-radio-group v-model="formData.recharge_status">
          <el-radio :label="1">
            <span style="color: #67C23A; font-weight: bold">充值成功</span>
          </el-radio>
          <el-radio :label="2">
            <span style="color: #F56C6C; font-weight: bold">充值失败</span>
          </el-radio>
        </el-radio-group>
        <div style="margin-top: 10px; font-size: 12px; color: #909399">
          <i class="el-icon-info"></i>
          充值成功后，系统将自动计算并记录佣金
        </div>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息（成功时为操作说明，失败时为失败原因）"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateRechargeStatus } from '@/api/order'

export default {
  name: 'RechargeStatusDialog',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      formData: {
        order_no: '',
        package_name: '',
        price: '',
        recharge_status: 1,
        remark: ''
      },
      rules: {
        recharge_status: [
          { required: true, message: '请选择充值状态', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(orderData) {
      this.dialogVisible = true
      this.formData = {
        order_no: orderData.order_no,
        package_name: orderData.package_name,
        price: parseFloat(orderData.price).toFixed(2),
        recharge_status: 1,
        remark: ''
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.rechargeForm.resetFields()
    },
    async handleSubmit() {
      this.$refs.rechargeForm.validate(async valid => {
        if (!valid) return

        this.submitLoading = true
        try {
          await updateRechargeStatus({
            order_no: this.formData.order_no,
            status: this.formData.recharge_status,
            remark: this.formData.remark
          })

          this.$message.success('充值状态更新成功')
          this.handleClose()
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || '更新失败')
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
